import { connect, useSelector } from "react-redux";
import {
    UpdatePasswordInput,
  UpdatePasswordInputError,
  UserProps,
} from "../../store/actionType";
import { UpdateUserPassword } from "../../store/action";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import PasswordUpdate from "./components/PasswordUpdateForm";

type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  userData: UserProps;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandlePasswordChange: React.FC<Props> = ({
  closeModal,
  onUpdatePassword,
  userData,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [formData, setFormData] = useState<UpdatePasswordInput>({
    password: "",
    confirm_password: "",
    current_password: "",
    user_id: userData.id
  });
  const userState = useSelector((state: any) => state.users.genericUserState);
  const [error, setError] = useState<UpdatePasswordInputError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const errors: UpdatePasswordInputError = {};
    if (!formData.password.trim()) errors.password = "Passowrd is required";
    if (!formData.current_password.trim()) errors.current_password = "Current Password is required";
    if (!formData.confirm_password.trim()) errors.confirm_password = "Confirm Password is required";
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (formData.password.trim() !== "" && formData.confirm_password.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      const input:UpdatePasswordInput = {
        confirm_password: formData.confirm_password || "",
        current_password: formData.current_password || "name",
        password: formData.password || "",
        user_id: formData.user_id || "",
      };
      try {
        await onUpdatePassword(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!userState.isLoading && submitted) {
      if (userState.error) {
        setApiError(userState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [userState?.isLoading, userState?.error, submitted, closeModal]);
  return (
    <>
      <PasswordUpdate
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Change Password"}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdatePassword: (input: UpdatePasswordInput) =>
    dispatch(UpdateUserPassword(input)),
});
export default connect(null, mapDispatchToProps)(HandlePasswordChange);
